<template>
  <el-dialog
    :visible="visible"
    title="编辑应用"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('openApiAuth.merchantName')" prop="storeId">
        <el-select v-model="form.storeId" :placeholder="$t('openApiAuth.selectMerchant')" style="width: 100%">
          <el-option :label="$t('openApiAuth.selectMerchant')" value=""></el-option>
          <el-option v-for="item in merchants" :key="item.storeId" :label="item.name"
            :value="item.storeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用ID" prop="appId">
        <el-input v-model="form.appId" disabled placeholder="应用ID"></el-input>
      </el-form-item>
      <el-form-item label="应用名称" prop="appName">
        <el-input v-model="form.appName" placeholder="请输入应用名称"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateOpenApiApp } from '@/api/system/openApiAuthApi'
import { listStores } from '@/api/admin/merchantManage/merchantManageApi'

export default {
  name: 'EditOpenApiApp',
  data() {
    return {
      visible: false,
      merchants: [],
      form: {
        appId: '',
        appName: '',
        storeId: '',
        status: '1',
        remark: ''
      },
      rules: {
        appId: [
          { required: true, message: '请输入应用ID', trigger: 'blur' }
        ],
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        storeId: [
          { required: true, message: '请选择商家', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this._listMerchants()
  },
  methods: {
    async _listMerchants() {
      try {
        const params = {
          page: 1,
          row: 100,
          storeTypeCd: '800900000005'
        }
        const response = await listStores(params)
        this.merchants = response.data
      } catch (error) {
        console.log('获取商家列表失败', error)
      }
    },
    open(app) {
      this.form = {
        appId: app.appId,
        appName: app.appName,
        storeId: app.storeId || '',
        status: app.status,
        remark: app.remark
      }
      this.visible = true
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const merchant = this.merchants.find(m => m.storeId === this.form.storeId)
            const params = {
              ...this.form,
              storeName: merchant ? merchant.name : '',
              storeAddress: merchant ? merchant.address : ''
            }
            const response = await updateOpenApiApp(params)
            if (response.code === 200) {
              this.$message.success('更新成功')
              this.$emit('success')
              this.visible = false
            } else {
              this.$message.error(response.msg || '更新失败')
            }
          } catch (error) {
            this.$message.error('更新失败')
          }
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.visible = false
      this.form = {
        appId: '',
        appName: '',
        status: '1',
        remark: ''
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>